import { render, staticRenderFns } from "./Non-Serialized-Inventory.vue?vue&type=template&id=2d070939"
import script from "./Non-Serialized-Inventory.vue?vue&type=script&lang=js"
export * from "./Non-Serialized-Inventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports